import { message } from '@cloud/atom-ui';

/**
 * 获取应用责任人和协同开发者
 * @param {应用id} appId
 * @param {当前页} page
 * @param {获取数据数} rows
 * @param {应用类型} type
 * @returns
 */
export const GetDevelopThunk = async (appId, memberType, page, rows,type) => {
  try {
    const editAppUrl = {
      innerapp: 'service/apps/manage/appowner',
      isv: 'service/isv/apps/manage/appowner'
    };
    const res = await fetch(
      `/${process.env.REACT_APP_API_CONTEXT}/${editAppUrl[type]}/${appId}?memberType=${memberType}&pageSize=${rows}&pageIndex=${page}&a=${new Date().getTime()}`,
      { method: "GET" }
    );
    if (res.status == 1) {
      return res.data;
    } else {
      message.error(res.errMsg);
      return [];
    }
  } catch (error) {
    return [];
  }
};

// 获取登陆者是否是协同开发者
export const getAppRole = async (appId,type) => {
  const fetchUrlPath = {
    innerapp: 'service/innerapp/role',
    isv: 'service/isv/app/role'
  };
  let url = `/${process.env.REACT_APP_API_CONTEXT}/${fetchUrlPath[type]}/${appId}`
  const result = await fetch(url, { method: "GET" });
  return result;
};
